import { getCleanStartorEndDay, yyyymmddDateRegex } from "helpers/utils";

// Only strict, existing YYYY-MM-DD days: "2026-13-45" would otherwise roll over to another date.
const isValidIsoDay = (value: unknown): value is string => {
    if (typeof value !== "string" || !yyyymmddDateRegex.test(value)) return false;
    const [year, month, day] = value.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
};

/**
 * Restores the date filter persisted in sessionStorage. The value is user-controlled
 * and older builds wrote it with `toLocaleDateString("en-CA")`, whose output depends on
 * the browser (e.g. an ambiguous "12/01/2026"), so anything that is not a strict
 * YYYY-MM-DD day is dropped and the page falls back to its default range.
 */
export const parseStoredAdvanceDateRange = (
    dateRange: { startDate?: unknown; endDate?: unknown } | undefined,
): { startDate: Date; endDate: Date } | undefined => {
    if (!dateRange || !isValidIsoDay(dateRange.startDate) || !isValidIsoDay(dateRange.endDate)) return;
    return {
        startDate: getCleanStartorEndDay(dateRange.startDate),
        endDate: getCleanStartorEndDay(dateRange.endDate, { time: "end" }),
    };
};
